<!--

  Usage:
    <ReportStatGrid :stats="[
      { label: 'Customers processed', value: 12480 },
      { label: 'Score increased', value: 340, tone: 'danger' },
      { label: 'Score decreased', value: 210, tone: 'success' },
      { label: 'Unchanged', value: 11930, tone: 'neutral' },
    ]" />
-->
<template>
  <div class="doc-stat-grid">
    <div class="doc-stat-card" v-for="(s, i) in stats" :key="i">
      <div class="doc-stat-label">{{ s.label }}</div>
      <div class="doc-stat-value" :style="'color:' + toneTextColor(s.tone)">
        {{ displayValue(s.value) }}
      </div>
    </div>
  </div>
</template>

<script>
import reportFormatMixin from '../mixins/reportFormat.mixin';

export default {
  name: 'ReportStatGrid',

  mixins: [reportFormatMixin],

  props: {
    stats: { type: Array, required: true },
  },

  methods: {
    displayValue(value) {
      return typeof value === 'number' ? value.toLocaleString() : value;
    },
  },
};
</script>